import { Form, Formik } from 'formik'
import React, { useState } from 'react'
import ReactTable from 'react-table'
import {
  DarkBlue,
  DarkBlueHover,
  DarkRedHover,
  Red,
} from '../../../../assets/colors'
import Button from '../../../../components/Button'
import Modal from '../../../../components/Modal'
import * as S from '../../../../components/ModalRemoveBatch/styles'

const ModalTotalLoss = ({ lossLot, confirmAction, cancelAction }) => {
  const title = 'Deseja marca perda total para esse lote ?'

  const closeModal = () => {
    cancelAction()
  }

  const [errorMessage, setErrorMessage] = useState('')

  return (
    <Modal
      show={lossLot !== undefined}
      closedButton={false}
      title={title}
      body={(
        <Formik
          initialValues={{
            badgeUser: undefined,
          }}
          onSubmit={(values, { setSubmitting }) => {
            confirmAction()
              .then(() => {
                closeModal()
              })
              .catch((error) => {
                if (error?.response) {
                  const { message } = error?.response.data
                  setErrorMessage(message)
                } else if (error?.message) {
                  const { message } = error
                  setErrorMessage(message)
                } else {
                  setErrorMessage(
                    'Não foi possivel marcar perda total para este lote',
                  )
                }
              })
              .finally(() => {
                setSubmitting(false)
              })
          }}
        >
          {({ isSubmitting, handleSubmit }) => (
            <Form style={{ padding: '0 20px 20px 20px' }}>
              <S.ModalBody>
                <h5>Informações do Lote</h5>
                <ReactTable
                  className='-striped -highlight'
                  data={lossLot ? [lossLot] : []}
                  resolveData={(data) => {
                    if (data) {
                      return data.map((row) => row)
                    }
                    return []
                  }}
                  resizable={false}
                  showPagination={false}
                  showPageSizeOptions={false}
                  loading={false}
                  columns={[
                    {
                      Header: 'Lote',
                      id: 'id_lote',
                      accessor: 'id_lote',
                      getProps: () => ({
                        style: {
                          textAlign: 'center',
                        },
                      }),
                    },
                    {
                      Header: 'Quantidade Total',
                      id: 'quantidade_total',
                      accessor: 'quantidade_total',
                      getProps: () => ({
                        style: {
                          textAlign: 'center',
                        },
                      }),
                    },
                  ]}
                  defaultPageSize={1}
                />
                {errorMessage && (
                  <p
                    style={{
                      color: 'red',
                      fontWeight: 'bold',
                      fontSize: '16x',
                    }}
                  >
                    {' '}
                    {errorMessage}{' '}
                  </p>
                )}
              </S.ModalBody>
              <S.ModalFooter>
                <Button
                  text='Perda Total'
                  style={{
                    marginRight: '5px',
                    height: '45px',
                    width: '150px',
                    padding: 0,
                    margin: 0,
                  }}
                  onClick={handleSubmit}
                  color={Red}
                  hoverColor={DarkRedHover}
                  isDisabled={isSubmitting}
                />

                <Button
                  text='Cancelar'
                  onClick={closeModal}
                  style={{
                    marginRight: '5px',
                    height: '45px',
                    width: '150px',
                    padding: 0,
                    margin: 0,
                  }}
                  color={DarkBlue}
                  hoverColor={DarkBlueHover}
                  isDisabled={isSubmitting}
                />
              </S.ModalFooter>
            </Form>
          )}
        </Formik>
      )}
    />
  )
}

export default ModalTotalLoss
